import { render } from "./MinePageView.vue?vue&type=template&id=a3f5d684&scoped=true"
import script from "./MinePageView.vue?vue&type=script&lang=js"
export * from "./MinePageView.vue?vue&type=script&lang=js"

import "./MinePageView.vue?vue&type=style&index=0&id=a3f5d684&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f5d684"]])

export default __exports__